import { useQuery } from "@tanstack/react-query";
import { getTeleconsultation } from "../services/teleconsultationService";

export const useTeleconsultation = (token?: string | null) => {
  return useQuery({
    queryKey: ["teleconsultation"],
    queryFn: () => getTeleconsultation(token as string),
    enabled: !!token,
    staleTime: 1000 * 60 * 30,
    gcTime: 1000 * 60 * 30
  });
};